import { useParams } from "react-router"

import { ENDPOINTS } from "@/constants/endpoints"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenericQuery } from "@/hooks/useGenericQuery"
import type { Round } from "@/types/roundTypes"

export const useEnrolledCoursesData = () => {
  //✅
  return useGenericQuery<Round[]>({
    keys: QUERY_KEYS.enrolledCourses.index(),
    apiEndpoint: ENDPOINTS.enrolledCourses.index(),
    paginated: true,
  })
}

export const useEnrolledByIdData = () => {
  //✅
  const { roundId } = useParams()

  return useGenericQuery<Round>({
    keys: QUERY_KEYS.enrolledCourses.show(Number(roundId)),
    apiEndpoint: ENDPOINTS.enrolledCourses.show(Number(roundId)),
    paginated: true,
    enabled: Boolean(roundId),
  })
}
